export class Bearing {
    static Zero() {
        return new Bearing(0);
    }
    static ClampAzimuth(a) {
        return ((a % 360) + 360) % 360;
    }
    constructor(value) {
        this._value = Bearing.ClampAzimuth(value);
        const rad = (this._value * Math.PI) / 180;
        this._cos = Math.cos(rad);
        this._sin = Math.sin(rad);
    }
    get value() {
        return this._value;
    }
    get radian() {
        return (this._value * Math.PI) / 180;
    }
    set value(v) {
        const clamped = Bearing.ClampAzimuth(v);
        if (this._value !== clamped) {
            this._value = clamped;
            const rad = (this._value * Math.PI) / 180;
            this._cos = Math.cos(rad);
            this._sin = Math.sin(rad);
        }
    }
    get cos() {
        return this._cos;
    }
    get sin() {
        return this._sin;
    }
    additiveInverse() {
        return new Bearing(-this._value);
    }
    copyInPlace(other) {
        this._value = other._value;
        this._cos = other._cos;
        this._sin = other._sin;
    }
    toString() {
        return `${this._value}°`;
    }
}
//# sourceMappingURL=geography.bearing.js.map